module.exports = __webpack_public_path__ + "img/upload-image.49c8b6b3.svg";